<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents ">
          <div class="row ">
            <div class="col-lg-3 col-md-4 col-sm-3 text-sm-left text-center">
              <div class="item-image text-center img-zoom-container position-relative" v-if="product[0].image">

                <div class="img-zoom-container d-sm-none d-md-block" onmousenter="showme(this)">
                  <span>
                    <p class="imgid" style="allign:center;">
                      <img id="myimage" :src="`${IMAGEURL}${product[0].image}`" :srcset="`${IMAGEURL}${product[0].image}`" width="260px">
                    </p>
                  </span>
                  <span id="myhide">
                    <div id="myresult" class="img-zoom-result" onmouseleave="hideme(this)"></div>
                  </span>
                </div>

                <image-zoom :regular="`${IMAGEURL}${product[0].image}`" :zoom="`${IMAGEURL}${product[0].image}`" :zoom-amount="3" img-class="d-none d-sm-block d-md-none" :alt="`${product[0].product_name}`">
                </image-zoom>

                <h4 v-if="product[0].award_title" class="details-award-title">
                  {{ product[0].award_title }}
                </h4>
              </div>
              <div v-else>Loading image...</div>
            </div>

            <div class="col-lg-9 col-md-8 col-sm-9">
              <div class="item-details">
                <div class="">
                  <div class="itemDetails">
                    <div>
                      <h2>{{ product[0].product_name }}</h2>
                    </div>

                    <h5 class="book-meta tangon">
                      মোট পৃষ্ঠা :
                      <span class="eng-text">{{
                          product[0].number_of_page
                      }}</span>
                    </h5>
                    <h5 class="book-meta">
                      <span class="tangon">প্রকাশের তারিখ :</span>
                      <span class="eng-text">{{
                          product[0].publish_date
                      }}</span>
                    </h5>
                    <h5 class="book-meta">
                      <span class="tangon">কভার টাইপ :</span>
                      <span class="eng-text">{{ product[0].paper_type }}</span>
                    </h5>

                    <div class="mt-2 font-18">
                      <div class="font-weight-bold">
                        <span v-if="product[0].discount > 0">
                          <strike>Tk. {{ Math.floor(product[0].orginal_price) }}</strike>
                        </span>
                        Tk. {{ Math.floor(product[0].price) }}

                        <span v-if="product[0].discount > 0" class="ml-2 text-success">
                            <label class="font-14" >You Save </label> Tk. {{ Math.floor(product[0].orginal_price - product[0].price) }}

                          <span v-if="product[0].discount_type == 'Percent'">({{ product[0].discount }}%)</span>
                        </span>
                      </div>
                    </div>

                    <div class="my-3">
                      <a v-if="product[0].preview_images && product[0].preview_images.length > 0" @click="readPdf(product[0])" href="javascript:;" class="btn btn-info btn-sm mr-1">
                        <i class="fa fa-file-pdf-o"></i> একটু পড়ে দেখুন
                      </a>

                      <button v-if="product[0].quantity > 0" class="btn btn-primary btn-sm" @click="addToCart(product, 2)">
                        <i class="fa fa-shopping-cart"></i> Add to Cart
                      </button>
                      <button v-else class="btn btn-primary btn-sm" disabled>
                        Out of Stock
                      </button>

                      <button class="btn btn-info btn-sm ml-1" @click="addToWishList(product)">
                        <i class="fa fa-heart"></i> Add to Wishlist
                      </button>

                      <div class="btn-group">
                        <button type="button" class="btn btn-secondary btn-sm ml-1 dropdown-toggle share-btn" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-share"></i> Share This Book
                        </button>
                        <div class="dropdown-menu dropdown-menu-lg-right share-btns">
                          <ShareNetwork v-for="network in networks" :network="network.network" :key="network.network" :style="{ backgroundColor: network.color }" :url="sharing.url" :title="sharing.title" :description="sharing.description" :quote="sharing.quote" :hashtags="sharing.hashtags" :twitterUser="sharing.twitterUser">
                            <i :class="network.icon"></i>
                            <!-- <button class="dropdown-item" type="button">{{ network.name }}</button> -->
                          </ShareNetwork>
                        </div>
                      </div>

                      <div class="share-network-list"></div>
                    </div>
                  </div>
                </div>

                <div class="item-description text-justify" v-html="`${product[0].description}`"></div>
                <div class="item-description text-justify" v-if="product[0].review" v-html="`${product[0].review}`"></div>
                <div class="item-description">
                  <div class="section-header">
                    <h3>মন্তব্য</h3>
                    <div v-if="message.length" :class="`alert alert-${messageType}`">
                      <ul class="m-0">
                        <li v-for="(item, key) in message" v-bind:key="key">
                          {{ item }}
                        </li>
                      </ul>
                    </div>

                    <form class="mb-2 mt-4" id="comments" @submit="checkForm" action="#" method="post">
                      <div class="form-row">
                        <div class="mb-2">
                          <div class="starrating risingstar d-flex justify-content-center flex-row-reverse">
                            <input type="radio" id="star5" name="rating" v-model="rating" value="5" />
                            <label for="star5" title="5 star"></label>
                            <input type="radio" id="star4" name="rating" v-model="rating" value="4" />
                            <label for="star4" title="4 star"></label>
                            <input type="radio" id="star3" name="rating" v-model="rating" value="3" />
                            <label for="star3" title="3 star"></label>
                            <input type="radio" id="star2" name="rating" v-model="rating" value="2" />
                            <label for="star2" title="2 star"></label>
                            <input type="radio" id="star1" name="rating" v-model="rating" value="1" />
                            <label for="star1" title="1 star"></label>
                          </div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for="inputAddress">Full Name</label>
                          <input type="text" class="form-control" v-model="full_name" id="inputAddress" placeholder="" autocomplete="off" />
                        </div>
                      </div>
                      <div class="">
                        <label for="inputAddress2">Comments</label>
                        <textarea type="text" class="form-control" v-model="comment" id="inputAddress2" placeholder="" autocomplete="off"></textarea>
                      </div>
                      <div class="row">
                        <div class="col-lg-12 text-right mt-2">
                          <button type="submit" class="btn btn-primary theme-bg">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>

                    <div class="card comments-box" v-if="comments.length > 0">
                      <div class="card-body">
                        <div class="comment-row" v-for="(commentRow, k) in comments" :key="k">
                          <div class="row">
                            <div class="col-lg-12">
                              <div>
                                <a class="pull-left" href="javascript:;"><strong>{{
                                    commentRow.full_name
                                }}</strong></a>
                                <span class="pull-right writer-name ml-3">
                                  <i v-for="index in commentRow.rating" :key="index" class="fa fa-star text-warning" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="text-muted my-2">
                                {{ commentRow.created_at }}
                              </div>
                              <div class="clearfix"></div>
                              <div v-html="commentRow.comment"></div>
                            </div>
                          </div>
                          <div class="card card-inner mt-2" v-if="commentRow.reply">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-lg-12">
                                  <div>
                                    <a href="javascript:;"><strong>প্রফেসর’স প্রকাশন</strong></a>
                                  </div>
                                  <div v-html="commentRow.reply"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="comments.length >= 10">
                        <button v-if="noOfComments == 'less'" class="pull-right btn btn-sm btn-primary btn-block" @click="seeAllComments">
                          See All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->

      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">

          <div class="row  mt-5" v-if="relatedProducts.length > 1">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>এই বিষয়ের আরও বইসমূহ</h3>
              </div>
              <div class="section-items ">
                <carousel :autoplay="true" :responsive="{
                  0: { items: 2, nav: false },
                  600: { items: 7, nav: false }
                }" :margin="10">
                  <BookCard
                    v-for="(item, key) in relatedProducts"
                    v-if="item.id != product[0].id"
                    :key="key"
                    :item="item"
                    hover-class="hover-item hover-item-scroll"
                    @add-to-cart="addToCart"
                  />
                </carousel>
              </div>
            </div>
          </div>

          <div class="row  mt-5" v-if="recentViews && recentViews.length > 0">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>সম্প্রতি দেখা বইসমূহ</h3>
              </div>
              <div class="section-items ">
                <carousel :autoplay="true" :responsive="{
                  0: { items: 2, nav: false },
                  600: { items: 7, nav: false }
                }" :margin="10">
                  <div v-for="(item, key) in recentViews" class="section-item books" :key="key">
                    <a :href="`${item.id}`">
                      <vue-load-image>
                        <img slot="image" v-bind:src="`${IMAGEURL}${item.json.image}`" alt="Image" class="img-responsive" />
                        <img slot="preloader" v-bind:src="`${IMAGEURL}/assets/img/loader.gif`" class="small-loader" title="Image Loading..." />
                        <div slot="error">can't load image</div>
                      </vue-load-image>
                      <h4 v-if="item.json.product_name.length < 14">
                        {{ item.json.product_name }}
                      </h4>
                      <h4 v-if="item.json.product_name.length >= 14" :title="`${item.json.product_name}`">
                        {{ item.json.product_name.substr(0, 14) + "..." }}
                      </h4>
                    </a>
                    <div class="hover-item hover-item-scroll">
                      <div class="arrow-up"></div>
                      <a :href="`${item.url}`" class="btn btn-black view-details">View Details</a>
                    </div>
                  </div>
                </carousel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" id="pdfModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body p-10 read-pdf text-center">
              <img v-for="(imageObj, index) in pdfToImageUrls" :key="index" v-bind:src="imageObj.image_url" class="responsive w-100" title="Image Loading..." />
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import carousel from "vue-owl-carousel";
import imageZoom from "vue-image-zoomer";
import BookCard from "../components/BookCard.vue";

export default {
  data() {
    return {
      pdfToImageUrls: null,
      shareTitle: "",
      shareDescription: "",
      shareQuote: "",
      product: [
        {
          product_name: "Loading...",
          description: "Loading...",
          review: "",
          image: ""
        }
      ],
      sharing: {
        url:
          this.baseUrl +
          "/book/" +
          this.$route.params.id,
        title: this.shareTitle || "",
        description: this.shareDescription,
        quote: this.shareQuote,
        hashtags: "প্রফেসর’স প্রকাশন",
        twitterUser: ""
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fa fa-facebook",
          color: "#1877f2"
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "fa fa-linkedin",
          color: "#007bb5"
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: "fa fa-pinterest",
          color: "#bd081c"
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fa fa-twitter",
          color: "#1da1f2"
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fa fa-whatsapp",
          color: "#25d366"
        }
      ],
      relatedProducts: [],
      relatedAuthorProducts: [],
      categoryId: null,
      errors: [],
      comments: [],
      messageType: "danger",
      message: "",
      full_name: null,
      comment: null,
      width: "auto",
      noOfComments: "less",
      rating: "5",
      recentViews: []
    };
  },
  components: {
    Layout,
    VueLoadImage,
    carousel,
    imageZoom,
    BookCard
  },
  methods: {
    readPdf(row) {
      if (row.preview_images && row.preview_images.length > 0) {
        this.pdfToImageUrls = row.preview_images;
        $("#pdfModal").modal("show");
      }
    },
    getProduct() {
      this.$http
        .get("products-resources/product-details/" + this.$route.params.id)
        .then(response => {
          this.product = response.data.data;
          this.categoryId = this.product[0].category_id;
          this.getRelatedProducts(this.product[0].category_id);
          this.shareTitle = this.product[0].product_name;
          this.shareDescription = this.product[0].description;
          //add to recent views
          let url = this.$route.fullPath;
          let data = {
            product_name: this.product[0].product_name,
            image: this.product[0].image
          };
          this.$helper.addToRecentlyViewed("recentViews", url, data, 10);
        })
        .catch(e => {
          this.product = null;
        });
    },
    getRelatedProducts(categoryId) {
      fetch(
        this.APIURL + "products-resources/category/" + categoryId + "/newest"
      )
        .then(response => response.json())
        .then(json => {
          this.relatedProducts = json.data;
          //console.log(json.data)
        });
    },
    getComments() {
      fetch(this.APIURL + "comment-resources/" + this.$route.params.id)
        .then(response => response.json())
        .then(json => {
          this.comments = json.data;

          //console.log('comments:'+JSON.stringify(json.data, null, 2))
        });
    },
    seeAllComments() {
      fetch(this.APIURL + "comment-resources/" + this.$route.params.id + "/all")
        .then(response => response.json())
        .then(json => {
          this.comments = json.data;
          this.noOfComments = "more";
          //console.log('comments:'+JSON.stringify(json.data, null, 2))
        });
    },
    checkForm: function (e) {
      if (this.full_name && this.comment) {
        e.preventDefault();
        let formData = new FormData();
        formData.append("rating", this.rating);
        formData.append("full_name", this.full_name);
        formData.append("comment", this.comment);
        formData.append("product_id", this.product[0].id);

        fetch(this.APIURL + "comment-resources", {
          method: "POST",
          body: formData
        })
          .then(response => response.json())
          .then(json => {
            //  console.log(json);
            this.messageType = "success";
            this.message.push(
              "Your comment has been added successfully and waiting for approval."
            );
            this.full_name = "";
            this.comment = "";
            this.getComments();
          });
      }

      this.message = [];
      if (!this.full_name) {
        this.message.push("Name required.");
      }
      if (!this.comment) {
        this.message.push("Comment required.");
      }

      e.preventDefault();
    },
    addToCart(row, type) {
      if (type == 2) {
        row = row[0];
      }
      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name
      };
      this.$helper.saveToCart(itemObj);
      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);
      this.flashMessage.success({ message: "Added item to cart" });
    },
    addToWishList(row) {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == "undefined"
      ) {
        localStorage.setItem("redirectUrl", "book/" + row[0].id);
        location.href = "/login";
      }

      let formData = {
        product_id: row[0].id
      };

      this.$http
        .post("wish-list-store", formData)
        .then(response => {
          if (response.data.status) {
            this.flashMessage.success({
              message: "Added to wishlist successfully."
            });
          } else {
            this.flashMessage.error({
              message: response.data.message
            });
          }
        })
        .catch(e => {
          //console.log(e);
        });
    },
    getCssClass(description){
      let descriptionAfterRemovedTags = description.replace( /(<([^>]+)>)/ig, '');
      return /^[a-z0-9]*$/i.test(descriptionAfterRemovedTags[0]) === true?'arial':'tangon';
    }
  },
  mounted() {
    this.getProduct();
    this.getComments();
    this.recentViews = JSON.parse(localStorage.getItem("recentViews"));
    console.log(this.baseUrl);
  },
  watch: {
    $route(to, from) {
      this.show = false;
    }
  }
};
</script>
